import { Modal } from "react-bootstrap";

import MembersForm from "../MembersForm";

export default function AddTeamMemberModal({
  show,
  setShow,
  reload,
  id,
  levels,
  refetch,
}) {
  const handleClose = () => {
    setShow(false);
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>+ ADD TEAM MEMBER</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MembersForm
          reload={reload}
          virtualTeamID={id}
          levels={levels}
          handleClose={handleClose}
          refetch={refetch}
        />
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}
